import React, {useState, useEffect} from "react";
import newStalbansLogo from '../assets/newStalbansLogo.png'
import visa from "../assets/visa.png";
import bank from "../assets/bank-transfer.png";
import discover from "../assets/discover.png";
import masterCard from '../assets/masterCard.png';
import transactionSuccess from '../assets/success_response.jpg'
import { Link, useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { getOfflineOrderTransactionResponseAPI, offlineTransactionResponseAPI, getStateList, getOfflineConvergeSessionToken } from '../serverApi/server'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { OrbitProgress } from 'react-loading-indicators';


export default function OfflineBillingPage() {
    const [searchParams] = useSearchParams();
    const queryParamData = searchParams.get('data');
    const [offlineOrderId, setOfflineOrderId] = useState()
    const [offlinePaymentLinkId, setOfflinePaymentLinkId] = useState()
    
    const [offlineOrderInvoiceNumber, setOfflineOrderInvoiceNumber] = useState('')
    const [cartItems, setCartItems] = useState([]);
    const [totalPrice, setTotalPrice] = useState('')
    const [loadingScreen, setLoadingScreen] = useState(true);
    const [billingPage, setBillingPage] = useState(false);
    const [linkExpiryPage, setLinkExpiryPage] = useState(false);
    const [transactionSuccessPage, setTransactionSuccessPage] = useState(false);
    const [minimumDepositAmount, setMinimumDepositAmount] = useState('')
    const [minimumDepositStatus, setMinimumDepositStatus] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('')

    var [billingData, setBillingData] = useState({
        firstName: "",
        lastName: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        email: "",
        phoneNumber: "",
        cardNumber: "",
        expiryDate: "",
        cvv: "",
        depositAmount: "",
        month: "",
        year: ""
    });

    const getOrderDetails = async (encryptedDetails) => {
        const getOrderDetailsResponse = await getOfflineOrderTransactionResponseAPI(encryptedDetails)
        if (getOrderDetailsResponse && getOrderDetailsResponse.data && getOrderDetailsResponse.data.client_status_code === 200 && getOrderDetailsResponse.data.id === 1) {
            setTimeout(()=>{
                 setLoadingScreen(false);
                setBillingPage(true);
            }, 2000)
            billingData.depositAmount= getOrderDetailsResponse.data.payment_method === "final_amount" ? parseFloat(getOrderDetailsResponse.data.offline_user_order_details_serializer.deposit_price).toFixed(2) : ""
            setPaymentMethod(getOrderDetailsResponse.data.payment_method)
            setOfflinePaymentLinkId(getOrderDetailsResponse.data.offline_payment_link_id)
            setOfflineOrderId(getOrderDetailsResponse.data.offline_user_order_details_serializer.id);
            setOfflineOrderInvoiceNumber(getOrderDetailsResponse.data.offline_user_order_details_serializer.offline_invoice);
            setCartItems(getOrderDetailsResponse.data.offline_user_order_details_serializer.carts);
            setTotalPrice(parseFloat(getOrderDetailsResponse.data.offline_user_order_details_serializer.total_price).toFixed(2))
            setMinimumDepositAmount(parseFloat(getOrderDetailsResponse.data.offline_user_order_details_serializer.total_price / 2).toFixed(2))
        } else if (getOrderDetailsResponse && getOrderDetailsResponse.data && getOrderDetailsResponse.data.client_status_code === 400 && getOrderDetailsResponse.data.id === 2) {
            setTimeout(()=>{
                setLoadingScreen(false);
                setLinkExpiryPage(true);
            }, 2000)
        } else if (getOrderDetailsResponse && getOrderDetailsResponse.data && getOrderDetailsResponse.data.client_status_code === 400 && getOrderDetailsResponse.data.id === 3) {
            setTimeout(()=>{
                setLoadingScreen(false);
                setLinkExpiryPage(true);
            }, 2000)
        }
    }

    useEffect( async ()=>{
      if (queryParamData) {
          await getOrderDetails(queryParamData)
      }
    }, [])


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [isPaymentFailed, setIsPaymentFailed] = useState(false);
    const [stateList, setStateList] = useState([]);
    const [errorsBill, setErrorsBill] = useState({});
    const [balanceDue, setBalanceDue] = useState();

    const fetchStateList = async () => {
        try {
        const response = await getStateList();
        if (response.data.client_status_code === 200) {
            setStateList(response.data.states_serializer_list);
        }
        } catch (error) {
        console.log('error fetching state', error);
        }
    }

    useEffect(() => {
        fetchStateList();
    }, []);

    

    useEffect(() => {
        if (billingData.depositAmount) {
            const total = parseFloat(totalPrice) || 0;
            const deposit = parseFloat(billingData.depositAmount) || 0;
            const balancePrice = total - deposit;
            setBalanceDue(parseFloat(balancePrice).toFixed(2));
        }
    }, [billingData.depositAmount])

    const handleBilling = (e) => {
        const { name, value } = e.target;
        setBillingData((prev) => ({
            ...prev,
            [name]: value
        }));
    };
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);

    const getOfflineConvergeSessionTokenFunction = async (depositAmount, offlineOrderId) => {

        try {
            const getOfflineConvergeSessionTokenResponse = await getOfflineConvergeSessionToken(depositAmount, offlineOrderId);
            if (getOfflineConvergeSessionTokenResponse.client_status_code === 200) {
                return getOfflineConvergeSessionTokenResponse.offline_order_session_token
            } else {
                return null
            }
        } catch (error) {
            console.error('Error fetching session token:', error);
        }
    };
    
    const offlineTransactionResponseFunction = async (payment_response, offline_order_id, offline_payment_link_id) => {
        try {
          const offlineTransactionAPIResponse = await offlineTransactionResponseAPI(payment_response, offline_order_id, offline_payment_link_id, billingData, balanceDue);
          if (offlineTransactionAPIResponse.data.client_status_code === 200) {
            return offlineTransactionAPIResponse.data
          } else {
            return null
          }
        } catch (error) {
          console.error('Error fetching session token:', error);
        }
    };

    const callback = {
        onError: async (error) => {
            console.log('\n 111111111111111111111111111111111111111 ')
            setIsSubmitting(false);
            setLoadingScreen(false);
            setIsPaymentFailed(true);
        },
        onDeclined: async (response) => {
            console.log('\n 222222222222222222222222222222222222222 ')
            setIsSubmitting(false);
            setLoadingScreen(false);
            setIsPaymentFailed(true);
        },
        onApproval: async (response) => {
            console.log('\n 33333333333333333333333333333333333333 ')
            const transactionDetailsResponse = await offlineTransactionResponseFunction(response, offlineOrderId, offlinePaymentLinkId);
            console.log('\n 44444444444444444444444444444444444444 ')
            setLoadingScreen(false);
            setBillingPage(false);
            setTransactionSuccessPage(true);
        },
    };

    const billingValidate = () => {
        const newErrors = {};
        if (!billingData.firstName) {
            newErrors.firstName = "First name is required.";
        } 
        if (!billingData.lastName) {
            newErrors.lastName = "Last name is required.";
        } 
        if (!billingData.address) {
            newErrors.address = "Address is required.";
        }
        if (!billingData.city) {
            newErrors.city = "City is required.";
        }
        if (!billingData.state) {
            newErrors.state = "State/Province is required.";
        }
        if (!billingData.zipCode) {
            newErrors.zipCode = "Postal code is required.";
        }
        if (!billingData.email || !/\S+@\S+\.\S+/.test(billingData.email)) {
            newErrors.email = "Valid email is required.";
        }
        if (!billingData.phoneNumber || billingData.phoneNumber.length < 10) {
            newErrors.phoneNumber = "Phone number must be at least 10 digits.";
        }
        if (!billingData.depositAmount) {
            newErrors.depositAmount = "Deposit amount is required.";
        }
        if (!billingData.cardNumber || billingData.cardNumber.length !== 16) {
            newErrors.cardNumber = "Card number must be 16 digits.";
        }
        if (!billingData.month || billingData.month.length == 0) {
            newErrors.expiryDate = "Expiration date must be in MM/YY format.";
        }
        if (!billingData.cvv || billingData.cvv.length !== 3) {
            newErrors.cvv = "CVV must be 3 digits.";
        }
        setErrorsBill(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const paymentSubmit = async (e) => {
        e.preventDefault();
        
        setIsSubmitting(true);
        setIsPaymentFailed(false);

        if (!billingValidate()) {
            setIsSubmitting(false);
            return;
        }
        if (!offlineOrderId && !billingData.depositAmount && !offlineOrderInvoiceNumber) {
            setIsSubmitting(false);
            return;
        }

        if (paymentMethod !== 'final_amount' && (parseFloat(billingData.depositAmount) < parseFloat(minimumDepositAmount))) {
          setMinimumDepositStatus(true);
          return;
        }

        setMinimumDepositStatus(false);
        setLoadingScreen(true);

        var billingAmount = paymentMethod !== 'final_amount' ? billingData.depositAmount : balanceDue

        const convergeSessionToken = await getOfflineConvergeSessionTokenFunction(billingAmount, offlineOrderId);
        const paymentData = {
          ssl_txn_auth_token: convergeSessionToken,
          ssl_card_number: billingData.cardNumber,
          ssl_exp_date: billingData.month.replace("/", ""),
          ssl_get_token: 'y',
          ssl_add_token: 'y',
          ssl_invoice_number: offlineOrderInvoiceNumber,
          ssl_first_name: billingData.firstName,
          ssl_last_name: billingData.lastName,
          ssl_cvv2cvc2: billingData.cvv,
          ssl_avs_address: billingData.address,
          ssl_city: billingData.city,
          ssl_state: billingData.state,
          ssl_avs_zip: billingData.zipCode,
        };

        if (offlineOrderId && billingAmount && offlineOrderInvoiceNumber && convergeSessionToken) {                                                                                                   
          window.ConvergeEmbeddedPayment.pay(paymentData, callback);
        } else {
          setLoadingScreen(false);
          setIsPaymentFailed(true);
        }
    }


    return (
      <div class="bg-gray-100 p-5 font-sans">
        <>
          {" "}
          {loadingScreen && (
            <div className="fixed top-0 left-0 w-full h-full bg-neutral-400 flex flex-col justify-center px-5 sm:px-8 items-center z-[150]">
              <div className="bg-white flex flex-col gap-3 sm:gap-5 p-8 sm:p-10 md:p-12 items-center rounded-lg animate-slide-down">
                <OrbitProgress
                  variant="spokes"
                  color="#d97116"
                  size="medium"
                  text=""
                  textColor=""
                />
              </div>
            </div>
          )}
          {billingPage && (
            <div class="max-w-5xl mx-auto bg-white p-6 shadow-lg rounded-lg">
              <div class="text-center">
                <img
                  src={newStalbansLogo}
                  alt="Stalbans Logo"
                  class="w-40 mx-auto"
                />
              </div>

              <h2 class="text-xl font-bold text-red-600 mt-6">
                Secure Payment Form
              </h2>

              <div class="flex border-b-2 border-gray-300 mt-4 mb-6">
                <div class="px-4 py-2 border border-gray-300 border-b-0 bg-gray-100 font-bold">
                  Transaction Details
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <div>
                    <p>
                      <strong>Product Name:</strong>{" "}
                      {cartItems.map((item) => item.category_name).join(", ")}
                    </p>
                  </div>
                  <h2 class="text-red-600 font-bold text-lg mt-6">
                    Billing Information
                  </h2>
                  <form class="space-y-4 mt-2">
                    <label class="block">
                      First Name*{" "}
                      <input
                        type="text"
                        name="firstName"
                        value={billingData.firstName}
                        onChange={handleBilling}
                        required
                        class="w-full mt-1 p-2 border border-gray-300 rounded"
                      />
                      {errorsBill.firstName && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.firstName}
                        </span>
                      )}
                    </label>
                    <label class="block">
                      Last Name*{" "}
                      <input
                        type="text"
                        name="lastName"
                        value={billingData.lastName}
                        onChange={handleBilling}
                        required
                        class="w-full mt-1 p-2 border border-gray-300 rounded"
                      />
                      {errorsBill.lastName && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.lastName}
                        </span>
                      )}
                    </label>
                    <label class="block">
                      Address*{" "}
                      <input
                        type="text"
                        name="address"
                        value={billingData.address}
                        onChange={handleBilling}
                        required
                        class="w-full mt-1 p-2 border border-gray-300 rounded"
                      />
                      {errorsBill.address && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.address}
                        </span>
                      )}
                    </label>

                    <div class="flex gap-4">
                      <label class="flex-1">
                        City*{" "}
                        <input
                          type="text"
                          name="city"
                          value={billingData.city}
                          onChange={handleBilling}
                          required
                          class="w-full mt-1 p-2 border border-gray-300 rounded"
                        />
                        {errorsBill.city && (
                          <span className="text-red-500 text-sm">
                            {errorsBill.city}
                          </span>
                        )}
                      </label>
                      <label class="flex-1">
                        State*{" "}
                        <select
                          name="state"
                          value={billingData.state}
                          onChange={handleBilling}
                          class="w-full mt-1 p-2 border border-gray-300 rounded"
                        >
                          <option value="">Select a state</option>
                          {stateList.map((state, index) => (
                            <option key={index} value={state.province_code}>
                              {state.name}
                            </option>
                          ))}
                        </select>
                        {errorsBill.state && (
                          <span className="text-red-500 text-sm">
                            {errorsBill.state}
                          </span>
                        )}
                      </label>
                    </div>

                    <label class="block">
                      Zip Code*{" "}
                      <input
                        type="text"
                        name="zipCode"
                        value={billingData.zipCode}
                        onChange={handleBilling}
                        required
                        class="w-full mt-1 p-2 border border-gray-300 rounded"
                      />
                      {errorsBill.zipCode && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.zipCode}
                        </span>
                      )}
                    </label>
                    <label class="block">
                      Phone Number*{" "}
                      <input
                        type="tel"
                        name="phoneNumber"
                        value={billingData.phoneNumber}
                        onChange={handleBilling}
                        required
                        class="w-full mt-1 p-2 border border-gray-300 rounded"
                      />
                      {errorsBill.phoneNumber && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.phoneNumber}
                        </span>
                      )}
                    </label>
                    <label class="block">
                      Email*{" "}
                      <input
                        type="email"
                        name="email"
                        value={billingData.email}
                        onChange={handleBilling}
                        required
                        class="w-full mt-1 p-2 border border-gray-300 rounded"
                      />
                      {errorsBill.email && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.email}
                        </span>
                      )}
                    </label>
                  </form>
                </div>

                <div class="bg-gray-100 p-4 border-4 border-red-500 rounded-xl w-full mx-auto">
                  <div>
                    <h2 class="text-red-600 font-bold text-lg mb-2">
                      Transaction Details
                    </h2>
                    <form class="space-y-4">
                      <label class="block">
                        Invoice Number*{" "}
                        <input
                          type="text"
                          value={offlineOrderInvoiceNumber}
                          readonly
                          required
                          class="w-full mt-1 p-2 border border-gray-300 rounded"
                        />
                      </label>
                      <label class="block">
                        Total Amount*{" "}
                        <input
                          type="text"
                          value={totalPrice}
                          readonly
                          class="w-full mt-1 p-2 border border-gray-300 rounded"
                        />
                      </label>
                      <label class="block">
                        {paymentMethod === 'final_amount' ? 'Previous Deposit Amount*' : 'Deposit Amount*'}
                        <input
                          type="text"
                          name="depositAmount"
                          onChange={handleBilling}
                          value={billingData.depositAmount}
                          readOnly={paymentMethod === 'final_amount'}
                          required
                          class="w-full mt-1 p-2 border border-gray-300 rounded"
                        />
                        {paymentMethod !== 'final_amount' && 
                          <span className={`${minimumDepositStatus ? 'text-red-500' : 'text-black'} text-sm`}>
                            A minimum payment of ${minimumDepositAmount} is required to proceed
                          </span>
                        }
                        {errorsBill.depositAmount && (
                          <><br/><span className="text-red-500 text-sm">
                            {errorsBill.depositAmount}
                          </span></>
                        )}
                      </label>
                      <label class="block">
                        {paymentMethod === 'final_amount' ? 'Amount Remaining to Pay*' : 'Balance Remaining*'}
                        <input
                          type="text"
                          value={balanceDue}
                          readonly
                          class="w-full mt-1 p-2 border border-gray-300 rounded"
                        />
                      </label>
                    </form>
                  </div>

                  <h2 class="text-red-600 font-bold text-lg mt-6">
                    Payment Information
                  </h2>
                  <form class="space-y-4 mt-2">
                    <label class="block">Payment Type: Credit Card</label>
                    <div class="flex gap-2 mt-1">
                      <img src={visa} alt="VISA" class="w-10" />
                      <img src={bank} alt="Bank Transfer" class="w-10" />
                      <img src={discover} alt="Discover" class="w-10" />
                      <img src={masterCard} alt="Master Card" class="w-10" />
                    </div>
                    <label class="block">
                      Card Number*{" "}
                      <input
                        type="text"
                        name="cardNumber"
                        value={billingData.cardNumber}
                        onChange={handleBilling}
                        required
                        class="w-full mt-1 p-2 border border-gray-300 rounded"
                      />
                      {errorsBill.cardNumber && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.cardNumber}
                        </span>
                      )}
                    </label>
                    <label className="block w-full">
                      Expiration*
                      <div className="flex gap-2 mt-1">
                        <DatePicker
                          selected={
                            billingData.month
                              ? new Date(
                                  `20${billingData.month.split("/")[1]}`,
                                  parseInt(billingData.month.split("/")[0]) - 1,
                                  1
                                )
                              : null
                          }
                          onChange={(date) => {
                            const month = (date.getMonth() + 1)
                              .toString()
                              .padStart(2, "0");
                            const year = date
                              .getFullYear()
                              .toString()
                              .slice(-2);
                            handleBilling({
                              target: {
                                name: "month",
                                value: `${month}/${year}`,
                              },
                            });
                            setIsCalendarOpen(false); // Close calendar after selecting
                          }}
                          onSelect={() => setIsCalendarOpen(false)}
                          onClickOutside={() => setIsCalendarOpen(false)}
                          onFocus={() => setIsCalendarOpen(true)}
                          open={isCalendarOpen}
                          dateFormat="MM/yy"
                          showMonthYearPicker
                          placeholderText="MM/YY"
                          className="w-full p-2 border border-gray-300 rounded cursor-pointer"
                        />
                      </div>
                      {errorsBill.expiryDate && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.expiryDate}
                        </span>
                      )}
                    </label>
                    <label class="block">
                      CVV*{" "}
                      <input
                        type="text"
                        name="cvv"
                        value={billingData.cvv}
                        onChange={handleBilling}
                        class="w-full mt-1 p-2 border border-gray-300 rounded"
                      />
                      {errorsBill.cvv && (
                        <span className="text-red-500 text-sm">
                          {errorsBill.cvv}
                        </span>
                      )}
                    </label>

                    <div class="text-lg font-semibold">
                      Amount Payable:{" "}
                      <strong>
                        {paymentMethod !== 'final_amount' && billingData.depositAmount
                          ? `$${billingData.depositAmount}`
                          : `$${balanceDue}`}
                      </strong>
                    </div>
                  </form>
                  <button
                    onClick={paymentSubmit}
                    type="submit"
                    class="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-2 rounded"
                  >
                    Process Payment
                  </button>
                </div>
              </div>

              <div class="h-1 bg-red-500 my-6"></div>

              <div class="text-center text-sm text-gray-700 mt-2 border-t pt-2">
                <p class="mb-1">
                  We are here to assist you{" "}
                  <span class="font-medium">Monday through Friday</span>, from{" "}
                  <span class="font-medium">10:00 AM to 7:00 PM EST</span>.
                </p>

                <p class="mb-1">
                  <strong class="text-red-600">
                    Visit us online at{" "}
                    <a
                      href="https://www.stalbansprinting.com"
                      class="hover:underline"
                    >
                      www.stalbansprinting.com
                    </a>
                    .
                  </strong>
                </p>

                <p class="mb-1 font-medium leading-snug">
                  St. Albans Digital Printing Inc, 199-12 Linden Blvd, Saint
                  Albans, NY 11412
                </p>

                <p class="font-semibold">
                  Call us:
                  <a
                    href="tel:18449446837"
                    class="text-red-600 hover:underline"
                  >
                    718-528-5100
                  </a>
                </p>
              </div>
            </div>
          )}
          <div>
            {isPaymentFailed && (
              <div className="fixed top-0 left-0 w-full h-full bg-neutral-400 flex flex-col justify-center px-5 sm:px-8 items-center z-[150]">
                <div className="bg-white flex flex-col gap-3 sm:gap-5 p-8 sm:p-10 md:p-12 items-center rounded-lg animate-slide-down">
                  <h1 className="text-center text-neutral-700 text-xl sm:text-2xl min-[1600px]:text-4xl font-medium">
                    Your payment is declined
                  </h1>
                  <p className="text-base sm:text-lg min-[1600px]:text-2xl text-center text-neutral-500 font-light">
                    The transaction was declined. Please use a different card or
                    contact issuer.
                  </p>
                  <div className="flex gap-3 sm:gap-4 md:gap-6 justify-end">
                    <button
                      className="text-[15px] md:text-base min-[1600px]:text-xl border border-neutral-400 font-medium block sm:inline text-neutral-700 bg-neutral-200 hover:bg-neutral-300 px-4 py-2 rounded md:px-4 md:py-[10px] duration-200"
                      onClick={() => setIsPaymentFailed(false)}
                    >
                      Return to Shop
                    </button>
                    <button
                      onClick={paymentSubmit}
                      className="block border-none rounded text-[15px] md:text-base min-[1600px]:text-xl font-medium text-white bg-yellow-500 hover:bg-yellow-600 px-4 py-2 md:px-4 md:py-[10px] duration-200"
                    >
                      Try again
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            {linkExpiryPage &&
                <div class="bg-gray-100">
                    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
                        <div class="bg-white rounded-lg shadow-lg p-6 sm:p-10 w-full max-w-md sm:max-w-2xl md:max-w-3xl text-center">
                            <h2 class="text-xl sm:text-2xl font-semibold text-gray-800">
                            Transaction Link Invalid or Expired
                            </h2>

                            <p class="text-base sm:text-lg text-gray-600 mt-4 sm:mt-6 leading-relaxed">
                            This payment link is no longer valid. It may have expired or
                            already been used.
                            <br />
                            If you need to complete your payment, please contact us at
                            <a href="tel:7185285100" class="text-blue-600 underline">
                                718-528-5100
                            </a>
                            or email
                            <a
                                href="mailto:orders@stalbansprinting.com"
                                class="text-blue-600 underline"
                            >
                                orders@stalbansprinting.com
                            </a>
                            .
                            </p>

                            <div class="mt-6 sm:mt-8 flex justify-center">
                            <a
                                href="https://www.stalbansprinting.com"
                                class="bg-yellow-500 hover:bg-yellow-600 text-white py-2 px-5 rounded text-sm sm:text-base transition"
                            >
                                Return to Shop
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
            }
          </div>
          <div>
            {transactionSuccessPage &&
                <div class="bg-gray-100">
                    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
                        <div
                            class="bg-white rounded-lg shadow-lg p-6 sm:p-10 w-full max-w-md sm:max-w-lg text-center"
                        >
                            <div class="flex justify-center mb-4">
                                <img src={transactionSuccess} alt="Success" class="w-16 h-16" />
                            </div>
                            <h2 class="text-xl sm:text-2xl font-semibold text-green-600">
                            Payment Successful!
                            </h2>
                            <p class="text-base sm:text-lg text-gray-600 mt-3 leading-relaxed">
                            Thank you for your payment. Your transaction was completed
                            successfully.
                            </p>
                            <div class="mt-6">
                                <a
                                    href="https://www.stalbansprinting.com"
                                    class="bg-green-500 hover:bg-green-600 text-white py-2 px-6 rounded text-sm sm:text-base transition"
                                >
                                    Go to Homepage
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            }
          </div>
        </>
      </div>
    );
}
